module.exports = __webpack_public_path__ + "assets/img/Futurama.1d49b80b-ps.jpg";